<template>
  <el-tabs v-model="activeTab" @tab-change="handleTabChange">
    <el-tab-pane label="平台用户" name="platform" />
    <el-tab-pane label="Excel导入" name="excel" />
  </el-tabs>

  <el-form
    ref="elFormRef"
    class="sms-send-form"
    :label-width="150"
    :model="formData"
    :rules="currentRules"
    size="small"
  >
    <!-- ====== 平台用户 Tab ====== -->
    <template v-if="activeTab === 'platform'">
      <el-form-item label="选择应用/会议/论坛" prop="meetingCode">
        <el-select
          v-model="formData.meetingCode"
          clearable
          filterable
          :loading="meetingLoading"
          placeholder="输入应用/会议/论坛名称"
          remote
          :remote-method="searchMeetings"
          style="width: 100%"
          @change="handleMeetingChange"
        >
          <el-option
            v-for="item in meetingOptions"
            :key="item.meetingCode"
            :label="item.name"
            :value="item.meetingCode"
          />
        </el-select>
      </el-form-item>

      <el-form-item v-if="formData.meetingCode" label="选择身份" prop="identities">
        <el-select
          v-model="formData.identities"
          clearable
          filterable
          multiple
          placeholder="请选择身份"
          style="width: 100%"
        >
          <el-option v-for="item in identityOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>

      <el-form-item v-if="formData.meetingCode" label="审核状态" prop="auditStatuses">
        <el-select
          v-model="formData.auditStatuses"
          clearable
          filterable
          multiple
          placeholder="请选择审核状态"
          style="width: 100%"
        >
          <el-option v-for="item in auditStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>

      <el-form-item v-if="formData.meetingCode" label="选择用户">
        <div>
          <div style="display: flex; align-items: center; gap: 8px">
            <el-button plain size="small" type="primary" @click="openUserPicker">选择用户</el-button>
            <span v-if="selectedUsers.length" style="color: #909399">已选择 {{ selectedUsers.length }} 人</span>
          </div>
          <div style="margin-top: 2px; color: #909399; font-size: 12px">
            指定用户精准发送；不选择则向符合条件的全部用户发送
          </div>

          <el-table
            v-if="selectedUsers.length"
            border
            :data="selectedUsers"
            size="small"
            style="margin-top: 6px"
            :table-layout="'auto'"
          >
            <el-table-column label="姓名" prop="name" />
            <el-table-column label="公司/机构" prop="company" show-overflow-tooltip />
            <el-table-column label="手机号" prop="phone" width="130" />
            <el-table-column align="center" label="操作" width="60">
              <template #default="{ row }">
                <el-link type="danger" :underline="false" @click="removeUser(row)">移除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
    </template>

    <!-- ====== Excel 导入 Tab ====== -->
    <template v-if="activeTab === 'excel'">
      <el-form-item label="模板下载">
        <el-link :href="EXCEL_TEMPLATE_URL" target="_blank" type="primary" :underline="false">
          短信号码导入模板.xlsx
        </el-link>
      </el-form-item>

      <el-form-item label="上传文件" prop="excelFile">
        <el-upload
          ref="uploadRef"
          accept=".xlsx,.xls"
          :auto-upload="false"
          :limit="1"
          :on-change="handleFileChange"
          :on-exceed="handleFileExceed"
          :on-remove="handleFileRemove"
        >
          <el-button plain size="small" type="primary">选择文件</el-button>
          <template #tip>
            <div style="color: #909399; font-size: 12px">
              仅支持 .xlsx / .xls 文件，不超过 3MB；第一列区号，第二列手机号
            </div>
          </template>
        </el-upload>
      </el-form-item>
    </template>

    <!-- ====== 公共：定时发送 ====== -->
    <el-form-item label="定时发送">
      <el-switch v-model="formData.scheduled" />
    </el-form-item>

    <el-form-item v-if="formData.scheduled" label="发送时间" prop="sendTime">
      <el-date-picker
        v-model="formData.sendTime"
        clearable
        format="YYYY-MM-DD HH:mm"
        placeholder="请选择发送时间"
        style="width: 100%"
        type="datetime"
        value-format="YYYY-MM-DD HH:mm"
      />
    </el-form-item>
  </el-form>

  <!-- 选择用户弹窗 -->
  <el-dialog
    append-to-body
    destroy-on-close
    :model-value="userPickerVisible"
    title="选择用户"
    :width="780"
    @close="userPickerVisible = false"
  >
    <el-table
      ref="userTableRef"
      v-loading="userLoading"
      border
      :data="userTableData"
      row-key="uid"
      :table-layout="'auto'"
      @select="handleUserSelect"
      @select-all="handleUserSelectAll"
    >
      <el-table-column align="center" :reserve-selection="true" type="selection" width="50" />
      <el-table-column label="姓名" prop="name" />
      <el-table-column label="公司/机构" prop="company" show-overflow-tooltip />
      <el-table-column label="手机号" prop="phone" width="130" />
      <el-table-column label="身份" prop="identityName" />
      <el-table-column label="审核状态" prop="auditStatusName" />
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <el-pagination
      v-model:current-page="userQueryParams.pageNum"
      background
      layout="prev, pager, next"
      :page-size="userQueryParams.pageSize"
      :total="userQueryParams.total"
      @current-change="queryUsers"
    />
    <template #footer>
      <el-button @click="userPickerVisible = false">取消</el-button>
      <el-button type="primary" @click="confirmUserPicker">确认选择（{{ tempSelectedUsers.length }}）</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
  import { ref, reactive, computed, nextTick, defineProps, defineEmits, defineExpose, getCurrentInstance } from 'vue'
  import { getSmsMeetings, getSmsUsers, saveUsersToGroup, createPhoneGroup, sendSms, smsImportExcel } from '@/api/sms'

  const EXCEL_TEMPLATE_URL =
    'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/SMS/%E7%9F%AD%E4%BF%A1%E5%8F%B7%E7%A0%81%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
  const MAX_FILE_SIZE = 3 * 1024 * 1024 // 3MB

  const props = defineProps({
    data: {
      type: Object,
      default: () => ({}),
    },
  })

  const emit = defineEmits(['success'])

  const { proxy } = getCurrentInstance()

  const elFormRef = ref()
  const uploadRef = ref()

  // ---- Tab 切换 ----
  const activeTab = ref('platform')

  function handleTabChange() {
    // 切换 tab 时重置表单校验
    nextTick(() => elFormRef.value?.clearValidate())
  }

  const auditStatusOptions = [
    { label: '通过', value: 'ACCEPT' },
    { label: '自主取消', value: 'CANCEL_SIGN' },
    { label: '拒绝', value: 'REFUSE' },
    { label: '审核中', value: 'PENDING_REVIEW' },
    { label: '无需审核', value: 'NOT_REVIEW' },
  ]

  const formData = reactive({
    meetingCode: '',
    identities: [],
    auditStatuses: [],
    excelFile: null,
    scheduled: false,
    sendTime: '',
  })

  const platformRules = {
    meetingCode: [{ required: true, message: '请选择应用/会议/论坛', trigger: 'change' }],
    sendTime: [{ required: true, message: '请选择发送时间', trigger: 'change' }],
  }

  const excelRules = {
    excelFile: [{ required: true, message: '请上传 Excel 文件', trigger: 'change' }],
    sendTime: [{ required: true, message: '请选择发送时间', trigger: 'change' }],
  }

  const currentRules = computed(() => (activeTab.value === 'platform' ? platformRules : excelRules))

  // ---- Excel 文件处理 ----
  function handleFileChange(file) {
    if (file.size > MAX_FILE_SIZE) {
      proxy.$baseMessage('文件大小不能超过 3MB', 'warning')
      uploadRef.value?.clearFiles()
      formData.excelFile = null
      return
    }
    formData.excelFile = file.raw
    elFormRef.value?.clearValidate('excelFile')
  }

  function handleFileRemove() {
    formData.excelFile = null
  }

  function handleFileExceed() {
    proxy.$baseMessage('只能上传一个文件，请先移除已有文件', 'warning')
  }

  // ---- 会议下拉 ----
  const meetingLoading = ref(false)
  const meetingOptions = ref([])
  const meetingMap = new Map()

  searchMeetings('')

  function searchMeetings(keyword) {
    meetingLoading.value = true
    getSmsMeetings({ keyword })
      .then(({ code, data }) => {
        if (code !== 200) return
        meetingOptions.value = data || []
        data?.forEach((item) => meetingMap.set(item.meetingCode, item))
      })
      .finally(() => {
        meetingLoading.value = false
      })
  }

  // ---- 身份下拉 ----
  const identityOptions = ref([])

  function handleMeetingChange(code) {
    formData.identities = []
    formData.auditStatuses = []
    selectedUsers.value = []

    if (!code) {
      identityOptions.value = []
      return
    }

    const meeting = meetingMap.get(code)
    if (!meeting?.identityList) {
      identityOptions.value = []
      return
    }

    identityOptions.value = meeting.identityList.map((item) => ({
      value: item.identityType,
      label: item.name,
    }))
  }

  // ---- 选择用户 ----
  const selectedUsers = ref([])
  const tempSelectedUsers = ref([])
  const userPickerVisible = ref(false)
  const userLoading = ref(false)
  const userTableData = ref([])
  const userTableRef = ref()

  const userQueryParams = reactive({
    pageNum: 1,
    pageSize: 10,
    total: 0,
  })

  function openUserPicker() {
    userPickerVisible.value = true
    tempSelectedUsers.value = [...selectedUsers.value]
    userQueryParams.pageNum = 1
    userQueryParams.total = 0
    queryUsers()
  }

  function queryUsers(pageNum = userQueryParams.pageNum) {
    const meeting = meetingMap.get(formData.meetingCode)
    const params = {
      meetingCode: formData.meetingCode,
      meetingType: meeting?.type,
      identityTypes: formData.identities.length ? formData.identities : undefined,
      auditStatuses: formData.auditStatuses.length ? formData.auditStatuses : undefined,
      pageNum,
      pageSize: userQueryParams.pageSize,
    }

    userLoading.value = true
    getSmsUsers(params)
      .then(({ code, data }) => {
        if (code !== 200) return
        const { list = [], total = 0 } = data || {}
        userTableData.value = list.filter((e) => !!e)
        userQueryParams.total = total

        // 恢复跨页选中状态
        nextTick(() => {
          if (!userTableRef.value) return
          const selectedUids = new Set(tempSelectedUsers.value.map((u) => u.uid))
          list.forEach((row) => {
            userTableRef.value.toggleRowSelection(row, selectedUids.has(row.uid))
          })
        })
      })
      .finally(() => {
        userLoading.value = false
      })
  }

  function handleUserSelect(selection, row) {
    const isSelected = selection.some((s) => s.uid === row.uid)
    if (isSelected) {
      if (!tempSelectedUsers.value.some((u) => u.uid === row.uid)) {
        tempSelectedUsers.value.push(row)
      }
    } else {
      tempSelectedUsers.value = tempSelectedUsers.value.filter((u) => u.uid !== row.uid)
    }
  }

  function handleUserSelectAll(selection) {
    const currentUids = new Set(userTableData.value.map((r) => r.uid))
    // 移除当前页所有
    tempSelectedUsers.value = tempSelectedUsers.value.filter((u) => !currentUids.has(u.uid))
    // 加回被选中的
    selection.forEach((row) => {
      tempSelectedUsers.value.push(row)
    })
  }

  function confirmUserPicker() {
    selectedUsers.value = [...tempSelectedUsers.value]
    userPickerVisible.value = false
  }

  function removeUser(row) {
    selectedUsers.value = selectedUsers.value.filter((u) => u.uid !== row.uid)
  }

  // ---- 提交 ----
  const submitting = ref(false)

  function submit() {
    elFormRef.value.validate((valid) => {
      if (!valid) return
      if (submitting.value) return
      submitting.value = true

      if (activeTab.value === 'excel') {
        submitExcel()
      } else {
        submitPlatform()
      }
    })
  }

  function submitPlatform() {
    const meeting = meetingMap.get(formData.meetingCode)
    const groupName = `sms_${Date.now()}`

    const getGroupNo = selectedUsers.value.length
      ? createPhoneGroup({
          sourceType: 'PLATFORM',
          uids: selectedUsers.value.map((u) => u.uid),
          groupName,
        })
      : saveUsersToGroup({
          groupName,
          meetingCode: formData.meetingCode,
          meetingType: meeting?.type,
          identities: formData.identities.length ? formData.identities : undefined,
          auditStatuses: formData.auditStatuses.length ? formData.auditStatuses : undefined,
        })

    getGroupNo
      .then(({ code, data: groupNo }) => {
        if (code !== 200) return Promise.reject()
        return sendSms({
          groupNo,
          templateId: props.data.id,
          scheduleTime: formData.scheduled ? formData.sendTime + ':00' : undefined,
        })
      })
      .then(({ code }) => {
        if (code !== 200) return
        proxy.$baseMessage('操作成功', 'success', 'vab-hey-message-success')
        emit('success')
      })
      .finally(() => {
        submitting.value = false
      })
  }

  function submitExcel() {
    const fd = new FormData()
    fd.append('file', formData.excelFile)
    fd.append('templateId', props.data.id)
    if (formData.scheduled && formData.sendTime) {
      fd.append('scheduleTime', formData.sendTime + ':00')
    }

    smsImportExcel(fd)
      .then(({ code }) => {
        if (code !== 200) return
        proxy.$baseMessage('操作成功', 'success', 'vab-hey-message-success')
        emit('success')
      })
      .finally(() => {
        submitting.value = false
      })
  }

  defineExpose({ submit })
</script>

<style lang="scss" scoped>
  .sms-send-form :deep(.el-form-item) {
    margin-bottom: 14px;
  }

  .sms-send-form :deep(.el-form-item__label) {
    line-height: 30px;
  }
</style>
